__turbopack_context__.v({
  "active": "contributors-module-scss-module__m9xt_q__active",
  "badge": "contributors-module-scss-module__m9xt_q__badge",
  "count": "contributors-module-scss-module__m9xt_q__count",
  "error": "contributors-module-scss-module__m9xt_q__error",
  "heading": "contributors-module-scss-module__m9xt_q__heading",
  "icon": "contributors-module-scss-module__m9xt_q__icon",
  "item": "contributors-module-scss-module__m9xt_q__item",
  "link": "contributors-module-scss-module__m9xt_q__link",
  "list": "contributors-module-scss-module__m9xt_q__list",
  "meta": "contributors-module-scss-module__m9xt_q__meta",
  "subtitle": "contributors-module-scss-module__m9xt_q__subtitle",
  "text": "contributors-module-scss-module__m9xt_q__text",
  "title": "contributors-module-scss-module__m9xt_q__title",
  "warning": "contributors-module-scss-module__m9xt_q__warning",
  "wrapper": "contributors-module-scss-module__m9xt_q__wrapper",
});
